<template>
  <el-card
    v-loading="loading"
    shadow="never">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
    >
      <el-form-item
        prop="name"
        label="会员姓名"
      >
        <el-input type="text" v-model="form.name" placeholder="请填写会员姓名"></el-input>
      </el-form-item>
      <el-upload
        class="avatar-uploader"
        :action="appApi"
        accept="image"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <span v-if="!imageUrl" class="avatar-uploader-icon">点击上传头像</span>
      </el-upload>
      <el-form-item
        class="customizeCss"
        prop="phone"
        label="联系方式"
      >
        <el-input type="text" @blur="triggerNextValidate" @change="synchronizePhone" :value="form.phone" placeholder="请填写联系方式"></el-input>
      </el-form-item>
      <el-form-item
        prop="memberNo"
        label="会员卡号"
      >
        <el-input ref="memberNoInput" type="text" @change="synchronizeMemberNo" :value="form.memberNo" placeholder="请填写会员卡号"></el-input>
      </el-form-item>
      <el-form-item
        prop="sex"
        label="性别"
      >
        <el-select v-model="form.sex" clearable placeholder="请选择性别">
          <el-option
            v-for="item in sexFlag"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="birthday"
        label="阳历生日"
      >
        <el-date-picker
          v-model="form.birthday"
          :editable="false"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="区域"
        class="customizeCssArea"
        prop="regionCode">
        <el-cascader
          :options="regionOptions"
          change-on-select
          @change="regionChange"
          :value="regionValue"
          :props="defaultRegionProps"
        ></el-cascader>
      </el-form-item>
      <el-form-item
        prop="addr"
        class="ipt-textarea"
        label="详细地址"
      >
        <el-input type="textarea" v-model="form.addr" placeholder="请填写详细地址"></el-input>
      </el-form-item>

      <el-form-item
        prop="remark"
        label="备注"
        class="ipt-textarea"
      >
        <el-input type="textarea" v-model="form.remark" placeholder="请填写备注" resize="none"></el-input>
      </el-form-item>

      <div class="tc">
        <el-button
          style="width: 140px"
          @click="goBack">返回
        </el-button>
        <el-button
          style="width: 140px"
          type="primary"
          @click="onSubmit">保存
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import {member, dict} from '../../api'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'
import {getSession} from '../../utils/session'
import {ORG_CODE, USER_ID} from '../../constants'
export default {
  name: 'ChannelManagementForm',
  props: {
    memberId: String
  },
  mounted () {
    this.getRegion()
    if (this.memberId) {
      this.getMemberDetailData()
    }
  },
  data () {
    let checkPhone = (rule, value, callback) => {
      if (value) {
        const mobilePhone = /^1[3456789]\d{9}$/
        if (mobilePhone.test(value)) {
          this.checkPhoneUnique().then((data) => {
            if (data) {
              callback()
            } else {
              return callback(new Error('手机号码重复'))
            }
          })
        } else {
          return callback(new Error('请填写正确的手机号'))
        }
      } else {
        callback()
      }
    }
    let checkMemberNoUnique = (rule, value, callback) => {
      if (value) {
        this.checkMemberNoUnique().then((data) => {
          if (data) {
            callback()
          } else {
            return callback(new Error('会员卡号重复'))
          }
        })
      } else {
        callback()
      }
    }
    return {
      appApi: process.env.VUE_APP_API + '/upload/image/single/',
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      defaultRegionProps: {
        value: 'id',
        label: 'name'
      },
      sexFlag: [{
        id: '1', name: '男'
      }, {
        id: '0', name: '女'
      }],
      regionOptions: [],
      regionValue: [],
      synchronizeInfo: '',
      imageUrl: '',
      form: {
        orgCode: getSession(ORG_CODE),
        memberId: '',
        name: '',
        phone: '',
        headImg: '',
        sex: '1',
        memberNo: '',
        solarFlag: true,
        birthday: '',
        province: '',
        city: '',
        county: '',
        regionCode: '',
        addr: '',
        createUser: getSession(USER_ID),
        remark: ''
      },
      rules: {
        name: [
          {required: true, message: '请填写会员姓名', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
        ],
        remark: [
          {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请填写联系方式', trigger: 'blur'},
          {validator: checkPhone, trigger: 'blur'}
        ],
        memberNo: [
          {required: true, message: '请填写会员卡号', trigger: 'blur'},
          {min: 1, max: 32, message: '最大 32 个字符', trigger: 'blur'},
          {validator: checkMemberNoUnique, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    triggerNextValidate () {
      let el = this.$refs['memberNoInput']
      el.focus()
      el.blur()
    },
    async getRegion () {
      this.loading = true
      let {data} = await dict.getRegion()
      this.regionOptions = data
      this.loading = false
    },
    async getMemberDetailData () {
      this.loading = true
      let {data} = await member.getMemberDetailData(this.memberId)
      this.loading = false
      this.regionValue = data.regionCodes
      if (data.headImg) {
        this.imageUrl = process.env.VUE_APP_IMG + data.headImg
      }
      this.synchronizeInfo = data.phone
      delete data.createTime
      this.form = data
    },
    async checkPhoneUnique () {
      this.loading = true
      let {data} = await member.checkPhoneUnique({
        memberId: this.form.memberId,
        phone: this.form.phone,
        orgCode: getSession(ORG_CODE)
      })
      this.loading = false
      return data
    },
    async checkMemberNoUnique () {
      this.loading = true
      let {data} = await member.checkMemberNoUnique({
        memberId: this.form.memberId,
        memberNo: this.form.memberNo,
        orgCode: getSession(ORG_CODE)
      })
      this.loading = false
      return data
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    },
    async onSubmit () {
      await this.$refs.form.validate()
      this.submitting = true
      if (this.form.memberId) {
        let {code, data} = await member.updateMember({
          ...this.form
        })
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '会员信息修改成功'
          })
          this.$bus.$emit('updateMemberList')
          this.$closeCurrentView()
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: '会员信息修改失败'
          })
        }
      } else {
        let {code, data} = await member.addMember(this.form)
        this.submitting = false
        if (code === 0) {
          this.form.memberId = data.memberId
          this.$message({
            type: 'success',
            message: '会员信息添加成功'
          })
          this.$bus.$emit('updateMemberList')
          this.$closeCurrentView()
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: '会员信息添加失败'
          })
        }
      }
    },
    regionChange (val) {
      this.form['regionCode'] = val[val.length - 1]
      this.$nextTick(() => {
        let regionResult = document.getElementsByClassName('el-cascader__label')[0].innerText.split('/')
        if (regionResult.length === 1) {
          this.form['province'] = regionResult[0].replace(/\s+/g, '')
        } else if (regionResult.length === 2) {
          this.form['city'] = regionResult[1].replace(/\s+/g, '')
        } else {
          this.form['county'] = regionResult[2].replace(/\s+/g, '')
        }
      })
    },
    synchronizePhone (val) {
      if (this.form.phone === this.form.memberNo) {
        this.form.memberNo = val
      }
      this.form.phone = val
    },
    synchronizeMemberNo (val) {
      this.form.memberNo = val
    },
    uploadSuccess (res, file) {
      this.loading = false
      this.imageUrl = process.env.VUE_APP_IMG + res.data
      this.form.headImg = res.data
    },
    uploadError () {
      this.loading = false
      this.$message({type: 'info', message: '插入图片失败，请稍后重试'})
    },
    beforeUpload (file) {
      let validImage1 = validImage(file, 500)
      this.loading = validImage1
      return validImage1
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-card {
    border: none;
    /deep/ .el-card__body {
      padding-top: 30px;
      .el-form {
        &.el-form--inline {
          width: 745px;
        }
        .el-form-item__content,
        .el-date-editor.el-input,
        .el-input--suffix {
          width: 232px;
        }
        .ipt-textarea {
          display: block;
          .el-form-item__content {
            width: 575px;
          }
        }
      }
      .el-upload,
      .el-upload--text {
        margin-left: 410px;
        margin-top: -58px;
      }
      .customizeCss {
        margin-top: -125px;
      }
      .customizeCssArea {
        margin-left: 307px;
        margin-top: -58px;
      }
    }
  }

  .el-input__icon {
    margin-right: 8px;
  }

</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
